var map = {
	"./amigo.png": "21e6",
	"./bgreg.png": "4149",
	"./duck.png": "d089",
	"./guarantee.png": "72ce",
	"./iphones.png": "9a93",
	"./location-marker.png": "9132",
	"./promo2022_ro.png": "b6d3",
	"./promo2022_ru.png": "c786",
	"./startCreate2.png": "a686",
	"./startCreate3.png": "f431",
	"./startCreate5.png": "1f18",
	"./visammp.png": "c0b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";